import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Input,
  Output,
  Inject,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { Data, Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PreviescreenComponent } from '../shared';
var turf = require('@turf/turf');

import 'leaflet';
import { environment } from 'src/environments/environment';
import { normalizeTaskTarget } from 'src/app/shared/utils/geo.utils';
import { isUmbraScanMode } from '../shared/utils/umbra-scan';
import { buildLeafletTaskStripPreview, LEAFLET_TASK_STRIP_SWATH_KM } from '../leaflet-task/leaflet-task-strip.utils';

declare var L: any;

@Component({
  selector: 'app-leaflet-newpreview',
  templateUrl: './leaflet-newpreview.component.html',
  styleUrls: ['./leaflet-newpreview.component.scss']
})
export class LeafletNewpreviewComponent implements OnInit {

  @Input() target: any = { geoJSON: '', area: 0 };
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  viewer: any = null;
  scene: any = null;
  longLatStr: string = '';
  latlonOverlay = document.createElement('div');
  taskTarget: any;
  taskid: any;
  taskname: any;
  coordinates: any = [];
  questionId: string;

  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  currentUser: any;
  taskMap: any;

  observationLocation: any;
  observationType: any;
  cordinateLabel: string = 'Coordinates';
  targetType = '';
  observationCoordinates: any = [];
  observationCoordinatesDisplay: any = [];
  sensors: any[] = [];
  private stripPreviewLayer: any = null;

  constructor(

    private dialogRef: MatDialogRef<PreviescreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private el: ElementRef, private renderer: Renderer2,
    private changDetectionRef: ChangeDetectorRef
  ) {
    
    this.taskid = data['taskid'];
    this.taskname = data['taskname'];
    this.sensors = data['sensors'] ?? [];
    this.taskTarget = JSON.parse(normalizeTaskTarget(this.data['target']));
    this.questionId = data['questionId']??'';
    this.observationLocation = data['observationLocation'];
    this.coordinates = [];
    // if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        this.coordinates = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
      } else if (this.taskTarget?.length > 1) {
        this.taskTarget.type = this.taskTarget[0].type;
        this.targetType = this.taskTarget[0].type;
        for (const points of this.taskTarget) {
          this.coordinates.push(points.coordinates)
        }
      } else {
        this.taskTarget.type = this.taskTarget.type;
        this.targetType = this.taskTarget.type;
        this.coordinates = this.taskTarget.coordinates;
      }

         if (this.observationLocation) {
      let observationCoordinatesSplit = this.observationLocation.includes(';') ? this.observationLocation.split(';') : this.observationLocation;
      this.observationCoordinatesDisplay = observationCoordinatesSplit.toString().split(',').map(Number);
      this.observationCoordinates = this.observationLocation.split(';');
      if (this.observationCoordinates.length === 1) {
        this.observationType = 'Point';
      } else {
        this.observationType = 'Polygon';
      }
      this.cordinateLabel = 'Tipping Coordinates';
    }
      
  }

  ngOnInit(): void {
    const imageryViewModels: any = [];
    const terrainViewModels: any = [];
  }

  @ViewChild('map', { static: true }) mapContainer!: ElementRef;
  private map!: any;
  zoomLevel = 3;
  mapDistance = 0;
  lattitude = 41.2;
  longitude = 74.66;
  latLngDMS = '';
  mapFontColor = 'white';

  ngAfterViewInit() {
    this.initializeMap();
    this.setupEventListeners();
    this.plotTargetNew('');
    const contentDiv = document.querySelector('.content');

    if (contentDiv) {
      contentDiv.addEventListener('mouseenter', () => {
        this.map.dragging.disable();
        this.map.scrollWheelZoom.disable();
        this.map.doubleClickZoom.disable();
        this.map.touchZoom.disable();
        this.map.boxZoom.disable();
        this.map.keyboard.disable();
        this.map.off('mousemove')
      });

      contentDiv.addEventListener('mouseleave', () => {
        this.map.dragging.enable();
        this.map.scrollWheelZoom.enable();
        this.map.doubleClickZoom.enable();
        this.map.touchZoom.enable();
        this.map.boxZoom.enable();
        this.map.keyboard.enable();
        this.map.on('mousemove', this.handleMouseMove)
      });
    }
  }

  private initializeMap(): void {
    const isSentinelBaseMapEnabled = environment.enableSentinelBaseMap === 'true';
    this.map = L.map(this.mapContainer.nativeElement, {attributionControl: false, minZoom: isSentinelBaseMapEnabled ? 7 : 1, maxZoom: 18}).setView(
      [this.lattitude, this.longitude],
      this.zoomLevel
    );
    const sentinelLayer = isSentinelBaseMapEnabled
  ? environment.isCopernicusLoad === "true"
    ? L.tileLayer(
      'https://sh.dataspace.copernicus.eu/ogc/wmts/f8b2a869-bd69-4ac6-8791-3443f116fa98' +
        '?SERVICE=WMTS' +
        '&REQUEST=GetTile' +
        '&VERSION=1.0.0' +
        '&LAYER=S2BASEMAP-LAYER' +
        '&STYLE=default' +
        '&FORMAT=image/png' +
        '&TILEMATRIXSET=PopularWebMercator256' +
        '&TILEMATRIX={z}' +
        '&TILEROW={y}' +
        '&TILECOL={x}',
      {
        tileSize: 256,
        opacity: 0.7
      }
    )
  : L.tileLayer(
      'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
      {
        tileSize: 256,
        opacity: 0.7
      }
    )
  : null;
    const baselayers = {
      Openstreetmap: L.tileLayer(
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ),
      ...(isSentinelBaseMapEnabled && sentinelLayer ? { Sentinel: sentinelLayer } : {})
    };
    let target: any;

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',  
      iconSize: [25, 41],                   
      iconAnchor: [12, 41],                  
      popupAnchor: [1, -34],                
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',  
      shadowSize: [41, 41],                   
      shadowAnchor: [12, 41]              
    });

    var overlays = {};
    L.control.layers(baselayers, overlays, {
      collapsed: false,  
      position: 'topright'  
    }).addTo(this.map);

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
    const sentinel2Layer = isSentinelBaseMapEnabled
      ? environment.isCopernicusLoad === "true"
        ? L.tileLayer(
            'https://sh.dataspace.copernicus.eu/ogc/wmts/f8b2a869-bd69-4ac6-8791-3443f116fa98' +
              '?SERVICE=WMTS' +
              '&REQUEST=GetTile' +
              '&VERSION=1.0.0' +
              '&LAYER=S2BASEMAP-LAYER' +
              '&STYLE=default' +
              '&FORMAT=image/png' +
              '&TILEMATRIXSET=PopularWebMercator256' +
              '&TILEMATRIX={z}' +
              '&TILEROW={y}' +
              '&TILECOL={x}',
            {
              attribution: '&copy;Sentinel-2 Cloudless by EOX'
            }
          )
        : L.tileLayer(
            'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
            {
              attribution:
                '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>',
              tileSize: 256,
              noWrap: true
            }
          )
      : null;

    if (!isSentinelBaseMapEnabled) {
      this.mapFontColor = 'black';
      baselayers['Openstreetmap'].addTo(this.map);
      this.map.setMinZoom(1);
      this.map.setMaxZoom(18);
    } else if (sentinel2Layer) {
      sentinel2Layer.addTo(this.map);
    }

    setTimeout(() => {
      const layersControlElement = document.querySelector('.leaflet-control-layers');
      if(layersControlElement){
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        container?.classList.remove('leaflet-control-layers-expanded');
      }
    }, 0);

    if (isSentinelBaseMapEnabled) {
      baselayers['Sentinel'].addTo(this.map);
    }

    this.map.on('baselayerchange', (event) => {

      if (event.name === "Openstreetmap") {
        this.mapFontColor = 'black';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
        myAttrControl.addAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
        this.map.setMinZoom(1);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 1) {
        this.map.setZoom(1);
        }
       if (this.map.getZoom() > 18) {
       this.map.setZoom(18);
    }
    
      } else if (isSentinelBaseMapEnabled) {
        this.mapFontColor = 'white';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
        myAttrControl.addAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
        this.map.setMinZoom(7);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 7) {
        this.map.setZoom(7);
        }
       if (this.map.getZoom() > 18) {
        this.map.setZoom(18);
       }
     }

    const elements = document.querySelectorAll('[id^="custom-div"]');
      elements.forEach((element: any) => {
        element.style.color = this.mapFontColor
      });
      this.removeHighlight();
      let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
      layerBtn?.classList.remove('highlight-border');

      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (container) {
        container.classList.remove('leaflet-control-layers-expanded');
        document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
      }
      const element = document.querySelector('#homeButton');
      if (element) {
        this.renderer.setStyle(element, 'z-index', '500');
      }
    });

    document.querySelector('.leaflet-control-layers-toggle')?.addEventListener('click', (e) => {
      this.removeHighlight();
      let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
      layerBtn.classList.add('highlight-border');
      if(document.querySelector('.leaflet-control-layers-expanded')) {
        document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-34px !important')
      }
    })

    this.map.on('click', () => {
      this.removeHighlight();
      document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (controlContainer?.classList?.contains('leaflet-control-layers-expanded')) {
          controlContainer?.classList?.remove('leaflet-control-layers-expanded');
      }
  });

    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);

    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);

    this.calculateZoomLevel();

    this.changDetectionRef.detectChanges();
  }

  private setupEventListeners(): void {
    this.map.on('zoomend', this.HandleZoomEnd);
    this.map.on('mousemove', this.handleMouseMove);
    this.map.on('move', this.handleMapMove);
    this.map.doubleClickZoom.disable();
  }

  removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if(homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
    if(layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    this.zoomLevel = this.map.getZoom();
    const bounds = this.map.getBounds();
    const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
    this.mapDistance = distance / 1000;
  };

  handleMouseMove = (e: any) => {
    this.latLngDMS = this.decimalToDMS(e.latlng.lat, e.latlng.lng);
  };

  handleMapMove = (e: any) => {
    this.updateDivPosition();
  }

  customDiv: any;
  updateDivPosition = () => {
    this.markersAndDivs.forEach((item, index) => {
      if (item.layer) {
        var point = this.map.latLngToContainerPoint(item.layer);
        this.markersAndDivs[index].div.style.left = point.x - 5 + 'px';
        this.markersAndDivs[index].div.style.top = point.y - 65 + 'px';
      }
    });
  }

  decimalToDMS(lat: number, lng: number): string {
    const convert = (decimal: number) => {
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      return `${degrees}° ${minutes}' ${seconds}"`;
    };
    const latitude = convert(lat) + (lat >= 0 ? ' N' : ' S');
    const longitude = convert(lng) + (lng >= 0 ? ' E' : ' W');
    return `Lng:${longitude}, Lat:${latitude}`;
  }
  eventLayers: any[] = [];
  viewHome(event: any) {

    this.removeHighlight();

    let layerList: any = document.querySelector('.leaflet-control-layers-expanded');
    if(layerList) {
      layerList.classList.remove('leaflet-control-layers-expanded');
    }

    document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')

    let homeBtn: any = document.querySelector('#homeButton');
    homeBtn.classList.add('highlight-border');

    let target: any;
    if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        const fpPos = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
        let modifiedArray = this.taskTarget.coordinates[0].map((sub) => {
          return [sub[1], sub[0]];
        });

        var polygon = L.polygon(modifiedArray, { color: 'yellow' }).addTo(
          this.map
        );
        this.map.fitBounds(polygon.getBounds());
      } else if (this.taskTarget?.length > 1) {
        if (this.taskTarget.type === 'Point') {
          this.generateMarkerNumber(this.taskTarget)
        }
        this.createGeoJSONFile(this.taskTarget);
        if (this.taskTarget.length === 2 && this.isUmbraScanSarTask()) {
          this.renderStripOverlay();
        }
        if(this.geojsonLayer) {
          this.map.fitBounds(this.geojsonLayer.getBounds())
        }
      } else if (this.taskTarget.type === 'Point') {
        const fpPos = this.taskTarget.coordinates;
        const lng = fpPos[0],
          lat = fpPos[1];
        this.map.setView([lat, lng], 3);
        L.marker([lat, lng]).addTo(this.map);
      }
      //observations
      if (this.observationCoordinates?.length > 0) {
      if (this.observationType === 'Point') {
        const [lng, lat] = this.observationCoordinates[0].split(',').map(Number);

        // Create a circle marker for the observation point
        const observationMarker = L.circleMarker([lat, lng], {
          radius: 5, // pixelSize equivalent
          color: 'red',
          fillColor: 'red',
          fillOpacity: 1,
          weight: 2
        }).addTo(this.map);


      } else if (this.observationType === 'Polygon') {
        const coords = this.observationCoordinates
          .map(c => c.split(',').map(Number))
          .map(coord => [coord[1], coord[0]]); 

        const observationLine = L.polyline(coords, {
          color: 'red',
          weight: 2
        }).addTo(this.map);
      }
    }

      // event?.stopPropagation();
  }

  setMapView(lat, lng) {
    this.map.setView([lat, lng], this.zoomLevel);
  }

  
  plotTargetNew(event: any) {
      this.viewHome(event);
  }

  createGeoJsonNew(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
    return geoJSON
  }

  markersAndDivs: any[] = [];
  generateMarkerNumber(features: any[]) {
    
    
    this.markersAndDivs.forEach((customDivs) => {
      customDivs.div.remove();
    })
    
    if(features.length > 1) {
      features.forEach((layer, i) => {
        let customDiv: any;
        let index = i+1;
        customDiv = document.createElement('div');
        customDiv.id = 'custom-div-' + index;
        customDiv.style.position = 'absolute';
        customDiv.style.zIndex = '400';
        customDiv.innerHTML = ''+index;
        customDiv.style.fontWeight = '700';
        customDiv.style.fontSize = '18px';
        customDiv.style.color = 'white';
        
        if (document) {
          (document as any).getElementById('map').appendChild(customDiv);
        }
        var point = this.map.latLngToContainerPoint([layer.coordinates[1], layer.coordinates[0]]);
        customDiv.style.left = point.x - 5 + 'px';
        customDiv.style.top = point.y - 65 + 'px';

        this.markersAndDivs[i] = {
          div : customDiv,
          layer: [layer.coordinates[1], layer.coordinates[0]]
        }
      })
    }
  }


  plotTarget() {
    let target: any,
      viewer = this.viewer;

    if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        const fpPos = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
        var bbox = turf.bbox(this.taskTarget);
      } else if (this.taskTarget?.length > 1) {
        this.createGeoJSONFile(this.taskTarget);
      } else if (this.taskTarget.type === 'Point') {
        const fpPos = this.taskTarget.coordinates;
      }
  }

  geojsonLayer: any;

  createGeoJSONFile(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };

    this.geojsonLayer = L.geoJSON(geoJSON).addTo(this.map);
  }

  flyHome() {
    this.viewer.camera.flyHome(2); 
  }

  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }
  onNoClick(msg: any): void {
    this.dialogRef.close('Done');   
  }

  private isUmbraScanSarTask(): boolean {
    return this.sensors.some((s: any) =>
      isUmbraScanMode({ key: s?.operatorKey ?? s?.key }, s?.collectionMode)
    );
  }

  private renderStripOverlay(): void {
    const pointWkts: string[] = this.taskTarget.map(
      (pt: any) => `POINT (${pt.coordinates[0]} ${pt.coordinates[1]})`
    );
    const preview = buildLeafletTaskStripPreview(pointWkts, LEAFLET_TASK_STRIP_SWATH_KM);
    if (!preview) return;
    if (this.stripPreviewLayer && this.map?.hasLayer(this.stripPreviewLayer)) {
      this.map.removeLayer(this.stripPreviewLayer);
    }
    this.stripPreviewLayer = L.polygon(preview.polygonLatLngs, {
      color: '#1e88e5',
      weight: 2,
      fillOpacity: 0.2,
      dashArray: '6 4',
      interactive: false,
    }).addTo(this.map);
  }

}
